import React, { useState, useEffect } from 'react';
import {
    Container,
} from '@mui/material';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import NewsForm from '../../components/form/news-form';

export default function NewsApprovalView() {
    return(
        <>
            <AdminMenu/>
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"News Preview"}
                    is_main_page={false}
                />
                <NewsForm
                    mode={'view'}
                    button_title={'บันทึก'}
                />
            </Container>
        </>
    )
}